import { BbState } from 'lib_ui-primitives';
import upsertRule from './didUpsert_identity_tenantSetting';

export const _private = { BbState };

export default {
    verb: 'didUpdate',
    namespace: 'identity',
    relation: 'tenantSetting',
    description:
        'proactively Update the tenantSettings used throughout the app while waiting for an update to come in over sockets',
    //this is the actual logic:
    logic
};

/**
 * @typedef {import("rulesengine.io").LoggingProvider} LoggingProvider
 * @typedef {import("rulesengine.io").WorkflowStack} WorkflowStack
 * @typedef {import("rulesengine.io").Context} Context
 *
 * @typedef {import('@sstdev/types').TenantSettings} TenantSettings
 */

/**
 * @param {{
 *   data: {newRecord:TenantSettings};
 *   prerequisiteResults: object[];
 *   context: Context;
 *   workflowStack: WorkflowStack[];
 *   dispatch: (data:object,context:Context,awaitResult?:boolean)=>Promise<void|any>
 *   log: LoggingProvider
 * }} parameters
 * @returns {Promise<void>}
 */
async function logic({ data, ...rest }) {
    // this rule really just proactively does exactly the same thing as the upsert rule
    // no need to do any more than just massage the data to match the upsert rule's expectations
    return upsertRule.logic({ data: { items: [data.newRecord] }, ...rest });
}
